declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export const gtagReportConversion = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'initiate_checkout',
  });
};
